export default "__VITE_ASSET__Bdn$pI40__"